// import { decodeJwt, JWTPayload } from 'jose';

// export const getTokenData = <T = any>(token: string) => {
//   if (!token) return null;

//   try {
//     const decoded: JWTPayload & T = decodeJwt(token);
//     return decoded;
//   } catch (error) {
//     console.log(error);
//     return null;
//   }
// };

/**
 * function that takes a key string like 'name' or 'name.first' and returns a function that takes an object and returns the value of the key in the object
 * @param obj - the object to get the value from
 * @param key - the key to get the value of you cane dots for nesting values
 */
export const getObjValue = <T = any>(obj: any, key: string | number) => {
  const keys = key.toString().split('.');
  let result = obj;
  for (const key of keys) {
    if (result && Object.hasOwn(result, key)) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  return result as T;
};

/**
 * Convert Like HEADER_NAME to header name
 * @param enumValue - the enum value to convert
 * @returns the converted value
 */
export const enumToString = (enumValue: string) => {
  return enumValue.charAt(0).toUpperCase() + enumValue.slice(1).toLowerCase().replace(/_/g, ' ');
};

export const generateId = (prefix: string) => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// return value if it is present, otherwise return false
export const isPresent = <T = any>(value: T) => {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  return value;
};

export const notNil = <T = any>(value: T) => {
  return value !== undefined && value !== null;
};

export const constructUrlWithParams = (
  url: string,
  params: Record<string, any> | undefined
) => {
  if (!params) return url;
  // remove undefined params
  const _params = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => {
      return v !== undefined && v !== null && v !== ''
    })
  );
  if (Object.keys(_params).length === 0) return url;
  return `${url}?${new URLSearchParams(_params).toString()}`;
}
